/**
 * Scroll Reveal - Fade in on scroll effect
 * Detecta quando elementos entram na viewport e adiciona animação
 */

(function() {
    'use strict';

    // Configuração do Intersection Observer
    const observerOptions = {
        threshold: 0.1, // 10% do elemento visível
        rootMargin: '0px 0px -50px 0px' // Trigger um pouco antes
    };

    // Callback quando elemento entra na viewport
    const observerCallback = (entries, observer) => {
        entries.forEach((entry, index) => {
            if (entry.isIntersecting) {
                // Adiciona delay baseado no index para efeito stagger
                const delay = entry.target.dataset.revealDelay || 0;

                setTimeout(() => {
                    entry.target.classList.add('revealed');
                }, delay);

                // Para de observar o elemento após revelar
                observer.unobserve(entry.target);
            }
        });
    };

    // Cria o observer
    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Função para inicializar o scroll reveal
    function initScrollReveal() {
        // Seleciona todos os elementos com classe 'reveal'
        const revealElements = document.querySelectorAll('.reveal');

        // Se há elementos com stagger, adiciona delay incremental
        const staggerContainers = document.querySelectorAll('.reveal-stagger');

        staggerContainers.forEach(container => {
            const children = container.querySelectorAll('.reveal');
            children.forEach((child, index) => {
                child.dataset.revealDelay = index * 100; // 100ms entre cada
            });
        });

        // Observa cada elemento
        revealElements.forEach(element => {
            observer.observe(element);
        });
    }

    // Inicializa quando o DOM estiver pronto
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initScrollReveal);
    } else {
        initScrollReveal();
    }

})();

